/**
 *  some variables
 */
let debug = false;

/**
 * hamburgers - burger menu - animation
 */
const burgerButton = document.getElementById('burger-menu-btn')

burgerButton.addEventListener('click', function () {
    burgerButton.classList.toggle('is-active')
})

$('body').scrollspy({ target: '#main-nav' })

/**
 * add background to sticky menu after scrolling down
 */

/*window.addEventListener('scroll', function () {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        //document.getElementById("call-line").classList.add('on-scroll')
        document.getElementById("nav-container").classList.add('on-scroll')
    } else {
        //document.getElementById("call-line").classList.remove('on-scroll')
        document.getElementById("nav-container").classList.remove('on-scroll')
    }
})*/

